import * as React from 'react';
import { connect } from 'react-redux';
import { pastOrders as actions } from './../../Actions';
import { Select } from '../../CommonUI';
import { PastOrdersPeriod } from '../../Model';

interface PeriodProps {
  setPeriod: (period: string) => void;
  period: string;
  disabled?: boolean;
}

const Period: React.SFC<PeriodProps> = ({period, setPeriod, disabled}) => {
  const onPeriodChange = (id: string, periodValue: string) => {
    return period !== periodValue ? setPeriod(periodValue) : undefined;
  };
  return (
    <Select
      id="position"
      label="enhancedPastOrders.periodSelector"
      localize={true}
      value={period}
      onChangeEvent={onPeriodChange}
      data={Object.keys(PastOrdersPeriod)}
      disabled={disabled}
    />
  );
};

const mapStateToProps = (state: any) => ({
  period: state.PastOrders.period,
});

const mapDispatchToProps = (dispatch: any) => ({
  setPeriod: (period: string) => dispatch(actions.setPeriod(period)),
});

export const PeriodComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Period);



// WEBPACK FOOTER //
// ./src/Components/EnhancedPastOrders/periodComponent.tsx